(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["delivery-estimate"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.delivery-estimate').forEach(function (el) {
    var cal = el.dataset.calendar === 'true';
    var addWorking = function (d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (cal || (x.getDay() !== 0 && x.getDay() !== 6)) n--; } return x; };
    var fmt = function (d) { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); };
    var dispatch = parseInt(el.dataset.dispatch, 10) || 0, transit = parseInt(el.dataset.transit, 10) || 8;
    var now = new Date();
    var latest = addWorking(now, dispatch + transit);
    var out = fmt(latest);
    if (el.dataset.showRange === 'true') { var earliest = addWorking(now, 1 + Math.max(1, transit - 3)); out = fmt(earliest) + ' – ' + fmt(latest); }
    el.querySelector('.delivery-estimate__date').textContent = out;
  });
  } catch(e) { console.error(e); }
})();

})();
